//统一管理api
import { base_bome } from "./base"; // 导入接口域名列表
import { post } from "./tool"; // 导入http中创建的axios实例
export const getNewGameList = (params) => post(base_bome + "/newgame/drama/list", params);
export const getNewGameDetail = (params) => post(base_bome + "/newgame/drama/detail", params);
export const getNewGameDetailStatus = (params) => post(base_bome + "/newgame/drama/user_mint_status", params);
export default { getNewGameList, getNewGameDetail, getNewGameDetailStatus };
